import * as actionTypes from "../actionTypes";
import { updateObject } from "../../shared/utility";

const initialState = {
  categories: null,
  categoryIcons: null,
  subcategories: null,
  subCategoriesLoading: false,
  serviceProviders: null,
  serviceProvidersDetails: null,
  serviceProvidersDetailsLoading: false,
  providerFiles: null,
  error: null,
  loading: false,
  serviceProviderPageLoading : false,
  isProviderTermsConditionsModal: false,
  isProviderTermsAndConditionAccepted: null,
  usersImageById: {}
};

// Get Provider Categories
const getProviderCategoryStart = (state: any) => {
  return updateObject(state, { error: null, loading: true });
};

const getProviderCategorySuccess = (state: any, action: any) => {
  return updateObject(state, {
    categories: state.categories
      ? {
          items: action?.categories && state?.categories?.items ? [...state?.categories?.items, ...action?.categories?.items]
            : action?.categories ? [...action?.categories?.items] : null,
          totalSize: action?.categories?.totalSize,
        }
      : action?.categories,
    error: null,
    loading: false,
  });
};

const getProviderCategoryFailed = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

// Get Provider Category Icons
const getProviderCategoryIconsStart = (state: any) => {
  return updateObject(state, { error: null, loading: true });
};

const getProviderCategoryIconsSuccess = (state: any, action: any) => {
  return updateObject(state, {
    categoryIcons: state.categoryIcons
      ? { ...state?.categoryIcons, ...action?.icon }
      : action?.icon,
    error: null,
    loading: false,
  });
};

const getProviderCategoryIconsFailed = (state: any, action: any) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

// Get Provider subcategories
const getProviderSubcategoryStart = (state: any) => {
  return updateObject(state, {
    error: null,
    subCategoriesLoading: true,
  });
};

const getProviderSubcategorySuccess = (state: any, action: any) => {
  return updateObject(state, {
    subcategories: state.subcategories
      ? {
          items: action?.subcategories && state?.subcategories?.items
            ? [...state?.subcategories?.items, ...action?.subcategories?.items]
            : action?.subcategories ? [...action.subcategories?.items]
            : null,
          totalSize: action?.subcategories?.totalSize,
        }
      : action?.subcategories,
    error: null,
    subCategoriesLoading: false,
  });
};

const getProviderSubcategoryFailed = (state: any, action: any) => {
  return updateObject(state, {
    subcategories: null,
    error: action.error,
    subCategoriesLoading: false,
  });
};

// Get Service Provider list
const getServiceProviderListStart = (state: any) => {
  return updateObject(state, {
    error: null,
    loading: true,
  });
};

const getServiceProviderListSuccess = (state: any, action: any) => {
  return updateObject(state, {
    serviceProviders: state.serviceProviders
      ? {
          items: action?.serviceProviders && state?.serviceProviders?.items
            ? [...state?.serviceProviders?.items, ...action?.serviceProviders?.items]
            : action?.serviceProviders ? [...action.serviceProviders?.items]
            : null,
          totalSize: action?.serviceProviders?.totalSize,
        }
      : action?.serviceProviders,
    error: null,
    loading: false
  });
};

const getServiceProviderListFailed = (state: any, action: any) => {
  return updateObject(state, {
    serviceProviders: null,
    error: action.error,
    loading: false,
  });
};

// Get Service Provider details based on userId
const getServiceProviderDetailsStart = (state: any, action: any) => {
  return updateObject(state, {
    error: null,
    serviceProvidersDetailsLoading: true,
  });
};

const getServiceProviderDetailsSuccess = (state: any, action: any) => {
  return updateObject(state, {
    serviceProvidersDetails: action.serviceProvider,
    error: null,
    serviceProvidersDetailsLoading: false,
  });
};

const getServiceProviderDetailsFailed = (state: any, action: any) => {
  return updateObject(state, {
    serviceProvidersDetails: null,
    error: action.error,
    serviceProvidersDetailsLoading: false,
  });
};
;
// Get Provider Files
const getProviderFilesStart = (state: any) => {
    return updateObject(state, { error: null, loading: true });
};

const getProviderFilesSuccess = (state: any, action: any) => {
    return updateObject(state, {
        providerFiles:  state.providerFiles ? {...state.providerFiles, ...action?.file} : action?.file,
        error: null,
        loading: false,
    });
};

const getProviderFilesFailed = (state: any, action: any) => {
    return updateObject(state, {
        error: action.error,
        loading: false,
    });
};

// get provider terms and condition

// ----------- Terms and condition ----------- //
const termConditionStart = (state: any) => {
  return updateObject(state, { error: null, loading: true });
};

const termConditionFinish = (state: any) => {
  return updateObject(state, { error: null, loading: false });
};

const setProviderTermsConditionsModal = (state: any, action: any) => {
  return updateObject(state, {
    isProviderTermsConditionsModal: action.state,
  });
};

// check if term and condition accepted or not
const getProviderTermsAndConditionStatusStart = (state:any) => {
  return updateObject(state, { error: null, loading: true });
};

const getProviderTermsAndConditionStatusSuccess = (state: any, action:any) => {
  return updateObject(state, { isProviderTermsAndConditionAccepted: action.data,error: null, loading: true });
};

const getProviderTermsAndConditionStatusFailed = (state: any, action:any) => {
  return updateObject(state, { isProviderTermsAndConditionAccepted: null,error: action.error, loading: true });
};

// accept terms and condition

const acceptProviderTermAndConditionStart = (state:any) => {
  return updateObject(state, { error: null});
};

const acceptProviderTermAndConditionSuccess = (state: any, action:any) => {
  return updateObject(state, { error: null });
};

const acceptProviderTermAndConditionFailed = (state: any, action:any) => {
  return updateObject(state, { error: action.error })
};

  // get user image by id
  const getUserImageFromIdStart = (state: any, ) => {
    return updateObject(state, {
      error: null,
    });
  };

  const getUserImageFromIdSuccess = (state: any, action:any) => {
    return updateObject(state, {
      usersImageById: {
        ...state.usersImageById, 
        [action.data?.msisdn]:
        action.data?.data,
      },
      error: null,
    });
  };

  const getUserImageFromIdFailed = (state: any, action:any) => {
    return updateObject(state, {
      error: action?.error,
    });
  };

/* Services Reducer */
const servicesReducer = (state = initialState, action: any) => {
  switch (action.type) {
    // Get Provider Categories
    case actionTypes.GET_PROVIDER_CATEGORY_START:
      return getProviderCategoryStart(state);
    case actionTypes.GET_PROVIDER_CATEGORY_SUCCESS:
      return getProviderCategorySuccess(state, action);
    case actionTypes.GET_PROVIDER_CATEGORY_FAIL:
      return getProviderCategoryFailed(state, action);

    // Get Provider Category Icons
    case actionTypes.GET_PROVIDER_CATEGORY_ICONS_START:
      return getProviderCategoryIconsStart(state);
    case actionTypes.GET_PROVIDER_CATEGORY_ICONS_SUCCESS:
      return getProviderCategoryIconsSuccess(state, action);
    case actionTypes.GET_PROVIDER_CATEGORY_ICONS_FAIL:
      return getProviderCategoryIconsFailed(state, action);
    // Get Provider subcategories
    case actionTypes.GET_PROVIDER_SUBCATEGORY_START:
      return getProviderSubcategoryStart(state);
    case actionTypes.GET_PROVIDER_SUBCATEGORY_SUCCESS:
      return getProviderSubcategorySuccess(state, action);
    case actionTypes.GET_PROVIDER_SUBCATEGORY_FAIL:
      return getProviderSubcategoryFailed(state, action);

    // Get Provider subcategories
    case actionTypes.GET_SERVICE_PROVIDERS_START:
      return getServiceProviderListStart(state);
    case actionTypes.GET_SERVICE_PROVIDERS_SUCCESS:
      return getServiceProviderListSuccess(state, action);
    case actionTypes.GET_SERVICE_PROVIDERS_FAIL:
      return getServiceProviderListFailed(state, action);

    // Get Provider subcategories
    case actionTypes.GET_SERVICE_PROVIDER_DETAILS_START:
      return getServiceProviderDetailsStart(state, action);
    case actionTypes.GET_SERVICE_PROVIDER_DETAILS_SUCCESS:
      return getServiceProviderDetailsSuccess(state, action);
    case actionTypes.GET_SERVICE_PROVIDER_DETAILS_FAIL:
      return getServiceProviderDetailsFailed(state, action);

    // Get Provider Files
    // Get Provider Files
    case actionTypes.GET_PROVIDER_FILES_START:
      return getProviderFilesStart(state);
    case actionTypes.GET_PROVIDER_FILES_SUCCESS:
      return getProviderFilesSuccess(state, action);
    case actionTypes.GET_PROVIDER_FILES_FAIL:
        return getProviderFilesFailed(state, action);

    case actionTypes.PROVIDER_TERMS_CONDITIONS_START:
      return termConditionStart(state);
    case actionTypes.PROVIDER_TERMS_CONDITIONS_FINISH:
      return termConditionFinish(state);
    case actionTypes.PROVIDER_TERMS_CONDITIONS_MODAL:
      return setProviderTermsConditionsModal(state, action);

    // Get Provider Files
    case actionTypes.GET_PROVIDER_TNC_STATUS_START:
      return getProviderTermsAndConditionStatusStart(state);
    case actionTypes.GET_PROVIDER_TNC_STATUS_SUCCESS:
      return getProviderTermsAndConditionStatusSuccess(state, action);
    case actionTypes.GET_PROVIDER_TNC_STATUS_FAIL:
      return getProviderTermsAndConditionStatusFailed(state, action);

    // Get Provider Files
    case actionTypes.ACCEPT_PROVIDER_TERMS_AND_CONDITION_START:
      return acceptProviderTermAndConditionStart(state);
    case actionTypes.ACCEPT_PROVIDER_TERMS_AND_CONDITION_SUCCESS:
      return acceptProviderTermAndConditionSuccess(state, action);
    case actionTypes.ACCEPT_PROVIDER_TERMS_AND_CONDITION_FAIL:
      return acceptProviderTermAndConditionFailed(state, action);
    
    // Get user image by id
    case actionTypes.GET_USER_IMAGE_FROM_ID_START:
      return getUserImageFromIdStart(state);
    case actionTypes.GET_USER_IMAGE_FROM_ID_SUCCESS:
      return getUserImageFromIdSuccess(state, action);
    case actionTypes.GET_USER_IMAGE_FROM_ID_FAIL:
      return getUserImageFromIdFailed(state, action);

    default:
      return state;
    }

};

export default servicesReducer;
